export const en = {
    invalidLinkTitle: `Invalid Reset Link`,
    invalidLinkDescription: `This reset link is invalid or expired`,
    invalidToken: `Invalid or missing reset token. Please request a new password reset.`,
    requestNewReset: `Request New Reset`,
    title: `Reset Password`,
    description: `Enter your new password for {email}`,
    success: `Password reset successfully! You can now sign in with your new password.`,
    redirect: `You will be redirected to the login page in {count} seconds...`,
    continueNow: `Continue to Sign In Now`,
    resetPasswordButton: `Reset Password`,
    failure: `Password reset failed. Please try again.`,
};
//# sourceMappingURL=en.js.map